import { Container, Grid, Segment, Icon, Image, Card } from "semantic-ui-react"
import { AuthoratorTitle } from '../utils/auth-title-name'
import { AuthStdFooter } from "../utils/auth-std-footer"
import aiPerson from '../assets/shutterstock_2280099283.jpg'
import narratorImg from '../assets/narrator_1.png'

export default function About() {
  const CardExampleImageCard = () => (
    <Card>
      <Image src={aiPerson} wrapped ui={false} />
      <Card.Content>
        <Card.Header>Thodkin</Card.Header>
        <Card.Meta>Joined in 2023</Card.Meta>
        <Card.Description>
          Thodkin is an AI Software Engineer...lots of those showing up these days.
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div className="a_button" >
          <Icon name='user' />
          less than 10 Friends
        </div>
      </Card.Content>
    </Card>
  )
  const aboutPage = () => {
    return (
      <>
        <div className="std-pg-main-area std-pg-grey-background-color" >
          <Container style={{ marginBottom: "200px" }}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} />
                <Grid.Column width={10}>
                  <>
                    <span className="aboutTitle">About </span>
                    <AuthoratorTitle size="7rem" />
                  </>
                </Grid.Column>
                <Grid.Column width={3} />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3} />
                <Grid.Column width={10} textAlign="center"><span className="">Our mission is to accelerate the transition of books to audio books...thru the wizardry of AI assisted narrator voice cloning. Assisted a bit by help tools needed for the task.</span></Grid.Column>
                <Grid.Column width={3} />
              </Grid.Row>
            </Grid>
            <Segment  >
              <Grid>
                <Grid.Row>
                  <Grid.Column ><span className="aboutTitle ">Why Us?</span></Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} >
                    <p className="aboutDetails_p ">
                      <span className="aboutBlockHighlight">Because</span> we use the coolest AI driven voice cloning available with some nice, understandable tools to guide you in the process.
                      <Image className="aboutHelperImage" src={narratorImg} size='medium' alt="Narrator" />

                    </p>
                  </Grid.Column>
                  <Grid.Column width={8}><p className="aboutDetails_p "><span className="aboutBlockHighlight">Ok, </span>it is true, you can pay people to narrate you books. Or, you can read it yourself. And, I’m sure you would get exactly what you imagine, after some effort. So, if you think that is right for you…go for it, we totally support and admire those qualities.</p>
                    <p className="aboutDetails_p "><span className="aboutBlockHighlight">In other cases,</span> if you could speed up the process, and manage tweaking and such more easily, maybe that is the right choice.</p>
                    <p className="aboutDetails_p "><span className="aboutBlockHighlight">For the second case, we are here to help.</span></p>
                    <p className="aboutDetails_p "><span className="aboutBlockHighlight">And, yes,</span> we have a long and personal story that drives us to make this possible…maybe another time we’ll get into that. But, for now, give our efforts a try…we will truly work to make it valuable to you.</p>
                  </Grid.Column>
                </Grid.Row>

              </Grid>
            </Segment>
            <Segment >
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}  ><span className="aboutTitle  centerText" >Our Team</span></Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={3}></Grid.Column>
                  <Grid.Column width={10} ><p className="aboutDetails_p "><span className="aboutBlockHighlight">Well, </span> we don’t have a very big team yet. Rather than bore you with the details, we’ll provide you with an imaginary team member, and fill this section as circumstances warrent…please stand by, but no sense holding your breath.</p></Grid.Column>
                  <Grid.Column width={3}></Grid.Column>
                </Grid.Row>
              </Grid>
              <div>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={6}></Grid.Column>
                    <Grid.Column width={4} >{CardExampleImageCard()}</Grid.Column>
                    <Grid.Column width={6}></Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Segment>

          </Container>
        </div >
        {AuthStdFooter()}
      </>
    )
  }
  return (<>{aboutPage()}</>)

} 